export default __webpack_public_path__ + "bcc68c98ff90add579e81ce3dff59cbb.png";